// If you don't want to use TypeScript you can delete this file!
import React from "react"
import { PageProps, Link, graphql } from "gatsby"

import Layout from "../../../components/layout"
import SEO from "../../../components/seo"

import './index.scss'
import ApiLogo from "../../../components/images/logo.api"
import GoToInstall from "../../../components/widgets/goToInstall"
import ImageFooted from "../../../components/widgets/imageFooted"
import { IMG_API } from "../../../components/images/docs/api"
import SectionNavigate from "../../../components/widgets/sectionNavigate"

type DataProps = {
    site: {
        buildTime: string
    }
}

const ApiReferenciaLanding: React.FC<PageProps<DataProps>> = ({ data, path, location }) => (
    <Layout isApi={true} location={location}>
        <SEO title="FiscalPOP para eCommerce" />
        <div id='ApiDocs' className="_DOCS">
            <div className="content">
                <h2>Validar usuario</h2>
                <ImageFooted explanation="Recibirás el siguiente correo con el token de validación (en negritas).">
                    <IMG_API file="validation" />
                </ImageFooted>
                <p>
                    Para realizar la activación ingresa al link proporcionado en el correo. Verás un simple texto con la nota siguiente, y al validar ya podrás hacer uso de la cuenta.
                </p>
                <pre>
                    <code>
                        Validation completed & user enabled!
                    </code>
                </pre>
                <p>
                    Cuentas que no hayan validado el correo, no podrán probar facturación y serán borradas después de 1 semana para evitar SPAM.  
                </p>
                <SectionNavigate next={`/api/referencia/clientes-agregar`} previous={`/api/referencia/usuarios-registro`}/>
            </div>
            <div className="side">

            </div>
        </div>
    </Layout>
)

export default ApiReferenciaLanding
